<template>
  <div class="news_con">
    <div class="tabs">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="t('index.privacy')" name="ystk"></el-tab-pane>
      <el-tab-pane v-for="item in baseinfo?.law" :label="item.dictLabel" :name="item.dictValue"></el-tab-pane>
    </el-tabs>
  </div>
    <div class="con">
      <div class="article-page01 map">
        <div class="w-83 wrap">
          <div class="title1" v-if="activeName == 'ystk'" style="text-align: center;">{{ t('login.jakaPolicy') }}</div>
          <div class="p f_16" style="line-height: 1.5;" v-html="activeName == 'ystk' ? baseinfo?.statementLaw: baseinfo.law?.filter(it=> it.dictValue == activeName)[0].content">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getBaseInfo } from '@/services/index.js'
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import formatImg, { formatUrlToLine } from '@/utils/formatImg.js'
const router = useRouter()

const { t, locale } = useI18n()
const baseinfo = ref([])
const activeName = ref('ystk')
// const 
console.log('baseinfo',window.location)
onMounted(() => {
  console.log('baseinfo',window.location)
  $('.header .con .h_left .h_nav>li a').removeClass('act')
  getBaseInfo().then(res => {
    console.log('baseinfo', res);
    baseinfo.value = res.data
  })
})

watch(
  () => router.currentRoute.value,
  (newValue) => {
    activeName.value = newValue.query.key || 'ystk'
  },
  { immediate: true }
)

const handleClick = (tab, event)=> {
  const path = `/imprint?key=${tab.props.name}`
  window.routerPush(formatUrlToLine(path))
}
</script>

<style scoped>
.tabs {
  margin: 1.5rem auto 0rem auto;
  width: 86%;
}
/* 网站地图 */
.article-page01 {
  margin: 0 auto;
  width: 86%;
}

.article-page01.map {
  /* margin-top: 0.6rem; */
  padding: 4.4vw 0 1rem;
}

.article-page01 .wrap {
  background-color: #fff;
  box-sizing: border-box;
}

.article-page01 .title1 {
  font-weight: 700;
  color: #000;
  margin-bottom: 30px;
  font-size: 22px;
  text-align: center;
}

.article-page01 {
  font-size: 16px;
}

.article-page01 strong {
  font-size: 18px;
}

@media only screen and (max-width: 1024px) {

  .article-page01.map,
  .article-page01 {
    padding: 40px 20px;
    margin-top: 50px;
    width: 100%;
  }

  .article-page01 .wrap {
    width: 100%;
    padding: 0;
  }
}
</style>
